import MobileDetect from 'mobile-detect';

const detector = new MobileDetect(window.navigator.userAgent);

export default detector;
